export default __webpack_public_path__ + "static/media/linkedin.24273993.svg";